import React, { useState } from 'react';
import axios from 'axios';

const Calculator = () => {
  const [result, setResult] = useState(null); // Store the calculation result
  const [numA, setNumA] = useState(''); // State variable for intA
  const [numB, setNumB] = useState(''); // State variable for intB

  const XMLData = (intA, intB) => `
    <soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd="http://www.w3.org/2001/XMLSchema" xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
      <soap:Body>
        <Add xmlns="http://tempuri.org/">
          <intA>${intA}</intA>
          <intB>${intB}</intB>
        </Add>
      </soap:Body>
    </soap:Envelope>`;

  const config = {
    headers: {
      'Content-Type': 'text/xml; charset=utf-8',
      'SOAPAction': 'http://tempuri.org/Add'
    }
  };

  const handleCalculate = async () => {
    try {
       // Generate XML with current input values
      const response = await axios.post('http://www.dneonline.com/calculator.asmx', XMLData(numA, numB), config);
      const parser = new DOMParser(); // Create a DOM parser
      const doc = parser.parseFromString(response.data, "text/xml"); // Parse the XML string
    
      const addResult = doc.querySelector('AddResult');
      setResult(addResult ? addResult.textContent : 'No result found');

    } catch (error) {
      console.error('Error:', error);
      setResult('Error occurred');
    }
  };

  return (
    <div>
      <label>
        intA:
        <input type="number" value={numA} onChange={(e) => setNumA(e.target.value)} />
      </label>
      <br />
      <label>
        intB:
        <input type="number" value={numB} onChange={(e) => setNumB(e.target.value)} />
      </label>
      <br />
      <button onClick={handleCalculate}>Calculatetyy</button>
      {result && <p>Result: {result}</p>}
    </div>
  );
};

export default Calculator;
